// import VacationDialogRequest from "#vacation/VacationDialogRequest"
import { UseVacationContext } from "#vacation/contexts/VacationContext"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import Button from "@mui/material/Button"
import MUIDataTable from "mui-datatables"
import { Fragment } from "react"
import VacationDetailsDialog from "./VacationDetailsDialog"
import VacationRequestDialog from "./vacation-request-dialog/VacationRequestDialog"

export default function VacationTable({ data, colaborador }) {
	const { setOpenRequest, setVacation } = UseVacationContext()

	const columns = [
		{
			name: "status_name",
			label: "Status",
			options: {
				filter: false,
				sort: false,
				empty: true,
			},
		},
		{
			name: "days",
			label: "Dias ",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "date_start",
			label: "Inicio",
			options: {
				filter: false,
				sort: false,
				empty: true,
			},
		},
		{
			name: "date_end",
			label: "Fin",
			options: {
				filter: true,
				sort: false,
			},
		},
		{
			name: "id",
			label: " ",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta) => {
					return <VacationDetailsDialog id={value} />
				},
			},
		},
	]
	const customToolbar = () => (
		<Button
			sx={{ height: "100%" }}
			variant="contained"
			size="small"
			onClick={() => {
				setOpenRequest(true)
				setVacation({ available_days: data.available_days, colaborador })
			}}
			startIcon={<AddCircleIcon />}
		>
			solicitar
		</Button>
	)

	const options = {
		textLabels: {
			body: {
				noMatch: "No hay solicitudes",
			},
		},
		rowsPerPage: 100,
		search: true,
		filter: true,
		download: true,
		print: false,
		viewColumns: false,
		selectableRows: "none",
		tableBodyHeight: "40vh",
		customToolbar,
	}

	return (
		<Fragment>
			<MUIDataTable
				title={"Vacaciones Solicitadas"}
				data={data.solicitudes?.data || []}
				columns={columns}
				options={options}
			/>

			<VacationRequestDialog />
		</Fragment>
	)
}
